"use client";

import Link from "next/link";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

export default function JoinHyraSection() {
  const t = useTranslations("user");
  return (
    <section className="relative px-4">
      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {/* <div className={`text-[128px]/[128px] font-open-sans font-normal bg-gradient-to-b from-black/[6%] to-transparent bg-clip-text text-transparent absolute left-1/2 -translate-x-1/2 -top-[60px]`}>
                    03
                </div> */}
      </motion.div>
      <div className="mt-20 flex flex-col items-center justify-center">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="text-center text-[48px] font-normal leading-[56px] tracking-[-1px] text-black">
            {t("join")} <span className="text-[#06F]">HYRA</span>{" "}
            {t("community")}
          </h2>
        </Reveal>
        <Reveal
          delay={0.4}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-5 max-w-[612px] text-center text-[16px]/[24px] font-light text-[#202020] opacity-[0.8]">
            {t(
              "join-the-thriving-hyra-network-community-where-innovators-creators-and-everyday-users-come-together-to-shape-the-future-of-decentralized-ai",
            )}
          </p>
        </Reveal>
      </div>

      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="mt-[44px] flex w-full items-center justify-center gap-6 max-sm:flex-col max-sm:gap-3 max-sm:px-6">
          <Link href={"/ecosystem"} className="max-sm:w-full">
            <button className="rounded-[12px] bg-[#06F] px-4 py-[14px] text-white max-sm:w-full">
              {t("explore-ecosystem")}
            </button>
          </Link>
          <Link href={"/news"} className="max-sm:w-full">
            <button className="rounded-[12px] border border-black/20 px-4 py-[14px] max-sm:w-full">
              {t("read-blog")}
            </button>
          </Link>
          <Link href={"/community"} className="max-sm:w-full">
            <button className="rounded-[12px] border border-black/20 px-4 py-[14px] max-sm:w-full">
              {t("join-community")}
            </button>
          </Link>
        </div>
      </motion.div>

      <div className="mt-2 h-[476px] overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover"
        >
          <source
            src="https://cdn-r2.hyra.network/hyra-network/ai-data.webm"
            type="video/webm"
          />
        </video>
      </div>
    </section>
  );
}
